export enum PackageState {
    New = 0,
    Done = 1,
    Archived = 2,
    Deleted = 3,
}